export default "__VITE_ASSET__Nx8bZs5b__"